var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17.9971,
    height: 17.9971,
    viewBox: "0 0 17.9971 17.9971",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_0_31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4983 1.49976H4.49927C4.10151 1.49976 3.72004 1.65777 3.43879 1.93903C3.15753 2.22029 2.99952 2.60176 2.99952 2.99952V14.9976C2.99952 15.3953 3.15753 15.7768 3.43879 16.0581C3.72004 16.3393 4.10151 16.4973 4.49927 16.4973H13.4978C13.8956 16.4973 14.2771 16.3393 14.5583 16.0581C14.8396 15.7768 14.9976 15.3953 14.9976 14.9976V5.99903L10.4983 1.49976Z",
    stroke: "#EF4444",
    strokeWidth: 1.49976
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.4983 1.49976V5.99903H14.9976",
    stroke: "#EF4444",
    strokeWidth: 1.49976
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9971,
    height: 17.9971,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.bb4d287fd0bb47389f79a4947af6568d.svg";
export { ForwardRef as ReactComponent };